'use strict';
const angular = require('angular');

export class ReportFilterModalComponent {
  /*@ngInject*/
  constructor($scope, CommunityService, $uibModal) {
    this.$scope = $scope;
    this.$uibModal = $uibModal;

    this.model = {};
    this.$scope.model = this.model;

    this.mapFileType = {
      'docx': "Word Document (DOCX)",
      'odt': 'Open Office Document (ODT)',
      'pdf': 'Portable Document Format (PDF)'
    };

    CommunityService.query(data => {
      this.communities = data.map(community => {
        return {
          value: community._id,
          name: community.code + ": " + community.name
        }
      });
    });

    $scope.$watch("model", _ => this.filterb64 = btoa(JSON.stringify(this.model)), true);
  }

  communityLookup() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'communityLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (community) {
        that.model.community = community._id;
      },
      function () { /* cancel */ }
    );

  }

  $onInit() {
    this.config = this.resolve.config;
    this.icon = this.config.icon || 'download';
    let fields =  [];

    this.config.filter.forEach(def => {
      let splittedDef = def.split(":");

      console.log(splittedDef);

      switch(splittedDef[0]) {
        case 'contacttypes':
          this.contactTypes = splittedDef[1].split(",");
          this.contactTypesMap = {};
          this.contactTypes.forEach(type => this.contactTypesMap[type] = true);
          this.updateModelContactTypes();
          fields.push(splittedDef[0]);
          break;
        default:
          fields.push(splittedDef[0]);
          break;
      }
    });

    this.fields = fields;

    let filetypes = this.config.fileTypes || ["docx"];
    this.fileTypes = filetypes.map(fileType => { return {fileType: fileType, name: this.mapFileType[fileType]} });

    this.model.report = this.config.report;
    this.model.template = this.config.template;
    this.model.fileType = this.config.defaultFileType || "docx";

    if (this.config.entityId) { // For Custom Entity Letters
      this.model.entityId = this.config.entityId;
      this.model.entityName = this.config.entityName;
      this.model.attach = this.config.attach;
      this.pickContactPreselects = this.config.pickContactPreselects;
    }

    this.filterb64 = btoa(JSON.stringify(this.model));
  };

  ok(model) {
    this.close({$value: model});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  getContactTypeName(type) {
    switch(type) {
      case 'primary-owner':
        return "Primary Owner";
      case 'owner':
        return "Owner";
      case 'renter':
        return "Renter";
      case 'previous-owner':
        return "Previous Owner";
      case 'visitor':
        return "Visitor";
      default:
        return type;
    }
  }

  updateModelContactTypes() {
    let selectedContactTypes = [];
    this.contactTypes.forEach(type => {
      if (this.contactTypesMap[type])
        selectedContactTypes.push(type);
    });
    this.model.contactTypes = selectedContactTypes;
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    this.$scope.$broadcast('schemaFormValidate');

    if (form.$valid) {
      this.ok(this.model);
    }
  }
}

export default angular.module('conduu.reportFilterModal', [])
  .component('reportFilterModal', {
    template: require('./report-filter-modal.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: ReportFilterModalComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/report-filter-modal/report-filter-modal.component.js